import React from 'react'
import styled from '@emotion/styled'
import { AccordianItem, AccordianItemDetails } from './AccordianItem'
import { mediaQueriesByDevice } from 'parameters/index'
import { Container } from 'components/layout'
import Image from 'next/legacy/image'
import loansImage from '../../../loans/assets/loans-xsell.jpg'

interface Props {
	title: string
	imageSrc: string
	items: AccordianItemDetails[]
}

export const AccordianSection = ({ title, items }: Props): JSX.Element => {
	const [activeIndex, setActiveIndex] = React.useState(0)

	return (
		<Container>
			<h2>{title}</h2>
			<Wrapper>
				<LeftColumn>
					<Image src={loansImage} alt="Loans Image" />
				</LeftColumn>
				<RightColumn>
					{items.map((item, index) => (
						<CrossSellItemHolder key={index}>
							<AccordianItem
								item={item}
								isActive={activeIndex === index}
								setActiveItem={(): void => setActiveIndex(index)}
							/>
						</CrossSellItemHolder>
					))}
				</RightColumn>
			</Wrapper>
		</Container>
	)
}

const Wrapper = styled.div`
	display: flex;
	margin-top: 40px;

	${mediaQueriesByDevice.tablet} {
		flex-direction: column;
		position: relative;
		margin-bottom: 180px;
	}
`

const LeftColumn = styled.div`
	margin-right: 40px;
	max-width: 634px;
	width: 100%;

	${mediaQueriesByDevice.tablet} {
		padding-right: 0;
		margin-left: -20px;
		margin-right: -20px;
		max-width: unset;
		width: unset;
	}
`

const RightColumn = styled.div`
	flex: 1;

	${mediaQueriesByDevice.tablet} {
		position: absolute;
		bottom: -175px;
		display: flex;
		flex-wrap: nowrap;
		overflow-x: auto;
		padding: 20px;
		margin: 0 -20px;
		-webkit-overflow-scrolling: touch;
		left: 0;
		right: 0;

		&::-webkit-scrollbar {
			display: none;
		}
	}
`

const CrossSellItemHolder = styled.div`
	${mediaQueriesByDevice.tablet} {
		padding-right: 16px;
	}
`
